import AppState from "../AppState";

export const selectSnackbarNotifications = (state: AppState) =>
  state.snackbar?.notifications || [];
